import { ApolloListItemType } from 'core/types/ApolloListQuery';
import {
  GetCandidatesByCandidateProfileQuery,
  GetOtherConversationsByCandidateProfileQuery,
  GetSourcedCandidatesByCandidateProfileQuery,
  GetAttachmentsByCandidateProfileQuery
} from 'generated-graphql/graphql';
import { create } from 'zustand';

type SourcedCandidateQueryItem =
  ApolloListItemType<GetSourcedCandidatesByCandidateProfileQuery>;

type CandidateByCandidateProfileQueryItem =
  ApolloListItemType<GetCandidatesByCandidateProfileQuery>;

type ConversationQueryItem =
  ApolloListItemType<GetOtherConversationsByCandidateProfileQuery>;

type AttachmentQueryItem =
  ApolloListItemType<GetAttachmentsByCandidateProfileQuery>;

type CandidateProfileStore = {
  sourcedCandidates: SourcedCandidateQueryItem[] | null;
  analysedApplications: CandidateByCandidateProfileQueryItem[] | null;
  conversations: ConversationQueryItem[] | null;
  attachments: AttachmentQueryItem[] | null;
  setSourcedCandidates: (
    sourcedCandidates: SourcedCandidateQueryItem[] | null
  ) => void;
  setAnalysedApplications: (
    analysedApplications: CandidateByCandidateProfileQueryItem[] | null
  ) => void;
  setConversations: (conversations: ConversationQueryItem[] | null) => void;
  setAttachments: (attachments: AttachmentQueryItem[] | null) => void;
};

export const useCandidateProfileStore = create<CandidateProfileStore>()(
  (set) => ({
    sourcedCandidates: null,
    analysedApplications: null,
    conversations: null,
    attachments: null,
    setSourcedCandidates: (sourcedCandidates) => set({ sourcedCandidates }),
    setAnalysedApplications: (analysedApplications) =>
      set({ analysedApplications }),
    setConversations: (conversations) => set({ conversations }),
    setAttachments: (attachments) => set({ attachments })
  })
);
